const averageDaysInYear = 365.25;
const averageDaysInMonth = 30.437;
const yearInMs = 1000 * 60 * 60 * 24 * 365;
const hourInMs = 3600000;
const minuteInMs = 60000;
const dayInMs = 1000 * 60 * 60 * 24;
const weekInMS = 1000 * 60 * 60 * 24 * 7;

export {
  averageDaysInMonth,
  averageDaysInYear,
  yearInMs,
  hourInMs,
  minuteInMs,
  dayInMs,
  weekInMS
};
